<template>
  <div class="invest">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.investors') }}
        </h3>
      </div>
      <div class="box-body">
        <div>
          <table
            id="invest-table"
            class="table table-hover table-striped table-bordered"
          >
            <thead>
              <tr>
                <th>{{ $t('table.action') }}</th>
                <th>{{ $t('table.createdAt') }}</th>
                <th>{{ $t('table.name') }}</th>
                <th>{{ $t('table.type') }}</th>
                <th>{{ $t('table.amount') }}</th>
                <th>{{ $t('table.phone') }}</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('string.investList'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
      this.loadAction()
    }
  },
  methods: {
    refreshDataTable () {
      this.oTable.draw(true)
    },
    deleteInvest (id) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          self.$axios.post(process.env.VUE_APP_API + '/api/v1/invests/delete', { id: id })
            .then((response) => {
              self.refreshDataTable()
              self.$swal({
                title: self.$t('string.deleted!'),
                text: self.$t('string.theRecordHasBeenDeleted!'),
                type: response.data.code === 1 ? 'success' : 'error',
                confirmButtonText: self.$t('button.ok')
              })
            })
            .catch((error) => {
              this.onResponseError(error)
            })
        }
      })
    },
    refreshTable () {
      const self = this
      return $('#invest-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/invests',
          data: (d) => {
            d.labelShow = self.$t('label.show')
            d.labelEdit = self.$t('label.edit')
            d.labelDelete = self.$t('label.delete')
            d.noPermission = self.$t('string.noPermission')
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            width: '8%',
            title: this.$t('table.action')
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            width: '8%',
            title: this.$t('table.createdAt')
          },
          { data: 'name', name: 'name', width: '8%', title: this.$t('table.name') },
          { data: 'invest_type.name', name: 'name', width: '8%', title: this.$t('table.type') },
          { data: 'amount', name: 'amount', width: '8%', title: this.$t('table.amount') },
          { data: 'phone', name: 'phone', width: '8%', title: this.$t('table.phone') }
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        fixedColumns: true
      })
    },
    loadAction () {
      this.clearEventHandlers([
        '.invest-show',
        '.invest-edit',
        '.invest-delete'
      ])
      const self = this
      $(document).on('click', '.invest-show', function () {
        var id = $(this).attr('data-invest')
        self.$router.push({
          name: 'InvestShow',
          params: {
            id: id
          }
        })
      })
      $(document).on('click', '.invest-edit', function () {
        var id = $(this).attr('data-invest')
        self.$router.push({
          name: 'InvestEdit',
          params: {
            id: id
          }
        })
      })
      $(document).on('click', '.invest-delete', function () {
        self.deleteInvest($(this).attr('data-invest'))
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.loadAction()
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
